import { Component, OnInit, ViewChild } from '@angular/core';
import { Order } from 'src/interfaces/order';
import { PrescriptionService } from "../../services/prescription.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { formatDistance } from "date-fns";
import { MatSort } from '@angular/material/sort';
import { LocalStorageService } from 'src/core/services/local-storage.service';
import { sageSyncLabelFromOrder } from 'src/interfaces/sage-sync-status';

@Component({
  selector: 'core-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit {

  displayedColumns: string[] = [
    'orderNumber',
    'owner',
    'status',
    'sage',
    'created_at'
  ];

  ordersDataSource: MatTableDataSource<Order>;
  totalNumberOfOrders: number = 0;
  page: number = 1;
  limit: number = 15;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private prescriptionService: PrescriptionService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {

    const limit = this.localStorageService.get('ORDERS', 'LIMIT');

    if (limit) {
      this.limit = parseInt(limit);
    }

    this
      .route
      .data
      .subscribe(data => {
        this.ordersDataSource = new MatTableDataSource<Order>(data.orders.orders);
        this.totalNumberOfOrders = this.prescriptionService.getTotalNumberOfOrders();
        this.ordersDataSource.sort = this.sort;
        this.page = data.orders.pageNumber;
      });

  }

  onPageChange(event: PageEvent) {
    // Get more orders 
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;

    this.localStorageService.store('ORDERS', 'LIMIT', this.limit.toString());
    this.localStorageService.store('ORDERS', 'PAGE', this.page.toString());

    (async () => {
      const newOrders = await this.prescriptionService.getOrders(this.page, this.limit);
      const newData = [...newOrders];
      this.ordersDataSource.data = newData;
    })();

    this.totalNumberOfOrders = this.prescriptionService.getTotalNumberOfOrders();
  }

  getSageSyncLabel(order: Order): string {
    return sageSyncLabelFromOrder(order);
  }

  openOrder(id: any) {
      this.router.navigate(["portal/shipping/details/", id]);
  }

  getIndividualId(order: Order) {

    if (order.client) return order.client.id;

    if (order.doctor) return order.doctor.id;

    if (order.patient) return order.patient.id;

    return null;
  }

  getCreationTime(order: Order) {
    return formatDistance(new Date(order.created_at), new Date(), { addSuffix: true });
  }

  getOwnerName(order: Order): string {

    if (order.client) return order.client.name;

    if (order.doctor) return order.doctor.first_name + " " + order.doctor.last_name;

    if (order.patient) return order.patient.first_name + " " + order.patient.last_name;

    return "No owner";
  }
}
